<template>
    <div class="task-notification-container">
        <div class="notification-header">
            <div class="header-icon">
                <span class="material-icons">notifications</span>
            </div>
            <div class="header-content">
                <h1 class="header-title">{{ $t('task.taskNotification.title') }}</h1>
                <p class="header-description">
                    {{ $t('task.taskNotification.description') }}
                </p>
            </div>
        </div>
        <section class="notification-content">
            <BasicActions
                :settings="settings"
                @update="updateScopeNotificationSettings"
                :title="group.title"
                v-for="group of groups"
                :key="group.id"
                :allowed-scopes="group.allowedScopes"
            />
        </section>
    </div>
</template>
<script>
import Vue from "vue";
import { ACTIVITY_API } from "../../api/activity";
import BasicActions from "../../views/Pages/Settings/pages/notification-settings/BasicActions.vue";

export default Vue.extend({
    name: "TaskNotification",
    components: { BasicActions },
    data() {
        return {
            loading: false,
            settings: [],
            groups: [
                {
                    id: "task",
                    title: this.$t("message.taskModule"),
                    allowedScopes: [
                        "task-crud",
                        "task-created",
                        "task-deleted",
                        "task-workflow-created",
                        "task-workflow-crud",
                        "task-assign",
                        "task-complet",
                        "task-archive",
                    ],
                },
            ],
        };
    },
    mounted() {
        this.fetchSettings();
    },
    methods: {
        updateScopeNotificationSettings(item, platform, value) {
            this.settings = this.settings.map((setting) => {
                if (setting.scope === item) {
                    setting[platform] = value;
                }
                return setting;
            });
        },
        fetchSettings() {
            this.loading = true;
            ACTIVITY_API.NOTIFICATION.getMySettings()
                .then((res) => {
                    this.settings = res.data;
                })
                .finally(() => {
                    this.loading = false;
                });
        },
    },
});
</script>

<style scoped lang="scss">
.task-notification-container {
    padding: 24px;
    background-color: #fff;
    border-radius: 8px;
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.05);

    .notification-header {
        display: flex;
        align-items: center;
        gap: 16px;
        padding-bottom: 20px;
        margin-bottom: 24px;
        border-bottom: 1px solid #f0f0f0;

        .header-icon {
            display: flex;
            align-items: center;
            justify-content: center;
            width: 48px;
            height: 48px;
            background-color: #ffe7e0;
            border-radius: 50%;
            color: #ec4b1d;

            .material-icons {
                font-size: 24px;
            }
        }

        .header-content {
            flex: 1;

            .header-title {
                font-size: 22px;
                font-weight: 600;
                color: #333;
                margin: 0 0 8px 0;
            }

            .header-description {
                font-size: 14px;
                color: #666;
                margin: 0;
                line-height: 1.5;
            }
        }
    }

    .notification-content {
        display: flex;
        flex-direction: column;
        gap: 16px;
        
        & > div {
            background-color: #f9f9f9;
            border-radius: 6px;
            padding: 16px;
            transition: all 0.2s ease;
            
            &:hover {
                background-color: #f5f5f5;
                box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
            }
        }
    }
}
</style>

